<button
    nzSize="default"
    nzType="text"
    class="got-search-toggle-button"
    nz-button
    (click)="toggleModal()"
>
    <nz-icon nzType="search"></nz-icon>
    <span class="got-search-hot-key"> SHIFT + SPACE </span>
</button>
<nz-modal
    nzWrapClassName="goto-modal"
    [nzNoAnimation]="true"
    [nzAutofocus]="null"
    [(nzVisible)]="isVisible"
    [nzTitle]="undefined"
    [nzFooter]="null"
    (nzOnCancel)="toggleModal()"
>
    <ng-container *nzModalContent>
        <nz-select
            #nzSelect
            (ngModelChange)="onChange($event)"
            nzOpen
            nzShowSearch
            nzAllowClear
            [nzPlaceHolder]="'i18n.global.actions.go_to' | translate"
            [(ngModel)]="selectedValue"
        >
            @for (item of list; track item.text) {
                @if (item.submenu) {
                    <nz-option
                        nzDisabled
                        nzCustomContent
                        [nzLabel]="item.text | translate"
                        [nzValue]="item.text"
                    >
                        @if (item.icon) {
                            <nz-icon [nzType]="item.icon"></nz-icon>
                        }
                        {{ item.text | translate }}
                    </nz-option>
                    @for (child of item.children; track child.text) {
                        <nz-option
                            nzCustomContent
                            [nzLabel]="child.text | translate"
                            [nzValue]="getLink(child)"
                        >
                            <div class="goto-child-item-content">
                                @if (child.icon) {
                                    <nz-icon [nzType]="child.icon"></nz-icon>
                                }
                                - {{ child.text | translate }}
                            </div>
                        </nz-option>
                    }
                } @else {
                    <nz-option
                        nzCustomContent
                        [nzLabel]="item.text | translate"
                        [nzValue]="getLink(item)"
                    >
                        @if (item.icon) {
                            <nz-icon [nzType]="item.icon"></nz-icon>
                        }
                        {{ item.text | translate }}
                    </nz-option>
                }
            }
        </nz-select>
    </ng-container>
</nz-modal>
